
define('text!libs/strand/test/imports/test-strand-tabs-aux.html',[],function () { return '<template preserve-content>\n\t<div id="aux"><h1>It works (external content)</h1></div>\n\t<div id="aux2"><h2>It works</h2></div>\n</template>\n';});

